// 统一管理 API 和 WebSocket 基础地址
// 从环境变量中读取配置，提供默认值

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
// export const API_BASE_URL = 'http://192.168.110.56:22225'
export const WS_BASE_URL = import.meta.env.VITE_WS_BASE_URL
// export const WS_BASE_URL = 'ws://192.168.110.56:22225'

// API 超时配置
export const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT) || 15000
export const STORAGE_TIMEOUT = parseInt(import.meta.env.VITE_STORAGE_TIMEOUT) || 30000

// Google Maps 配置
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

// Mapbox 配置
export const MAP_BOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZ290ZW5nIiwiYSI6ImNtbDk1eDJrdzAwYTUzY3B6bzBwejJrMHkifQ.Sn_H1zFLzt_PylKg8sOtLw'

// 是否开启组织管理
export const OPEN_ORG_MANAGEMENT = true